import { motion } from "framer-motion";
import { FaRobot } from "react-icons/fa";

const WelcomeScreen = ({ onStartChat, onHelpClick, onClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 30 }}
      transition={{ duration: 0.3 }}
      className="fixed top-[70px] right-4 sm:right-6 w-[90vw] sm:w-[400px] h-[80vh] sm:h-[630px] z-50 bg-gradient-to-b from-blue-500 to-blue-200 rounded-3xl shadow-lg p-6 flex flex-col font-serif"
    >
      <button
        onClick={onClose}
        className="self-end text-white text-2xl font-bold hover:text-gray-100"
      >
        −
      </button>

      <div className="text-white mt-2">
        <div className="text-4xl mb-2">
          <FaRobot />
        </div>
        <h2 className="text-2xl font-bold leading-tight">
          Welcome to the BL Query <br /> Agent Bot
        </h2>
      </div>

      <div className="bg-white rounded-xl p-4 mt-6 shadow-md">
        <div className="flex items-center space-x-3 mb-2">
          <div className="bg-blue-600 text-white rounded-full p-2">
            <FaRobot size={16} />
          </div>
          <p className="text-sm font-medium text-gray-700">Query Bot</p>
        </div>
        <p className="text-gray-800 mb-3">Let me know if you have any questions!</p>
        <button
         onClick={onHelpClick}
          className="bg-blue-600 hover:bg-blue-700 text-white w-full py-2 rounded-lg font-semibold transition"
        >
          Live chat
        </button>
        <button
          
 onClick={onStartChat}
          className="bg-blue-600 hover:bg-blue-700 text-white w-full py-2 mt-3 rounded-lg font-semibold transition"
        >
          Help me
        </button>
      </div>
    </motion.div>
  );
};

export default WelcomeScreen;
